import { CENTRAL_TIMEZONE } from '../../utils/timezone';

export const getTodayIsoDate = () =>
  new Date().toLocaleDateString('en-CA', { timeZone: CENTRAL_TIMEZONE });

export const MAX_DAF_BYTES = 15 * 1024 * 1024;
export const MAX_DAF_MB = 15;

export const isDafFileTooLarge = (file) =>
  Boolean(file && Number.isFinite(file.size) && file.size > MAX_DAF_BYTES);

export const getNextStage = (stage) => {
  if (stage === 'DAF') return 'D2C2';
  if (stage === 'D2C2') return 'Complete';
  return stage;
};

export const stageOptions = [
  { value: 'DAF', label: 'DAF' },
  { value: 'D2C2', label: 'D2C2' },
  { value: 'Complete', label: 'Complete' },
];

export const getBuySellMetrics = (rows = []) => {
  const counts = rows.reduce(
    (acc, row) => {
      const stage = row?.buySellStage || 'Unknown';
      acc.total += 1;
      acc.byStage[stage] = (acc.byStage[stage] || 0) + 1;
      return acc;
    },
    { total: 0, byStage: {} }
  );

  return {
    total: counts.total,
    byStage: counts.byStage,
    dafPending: counts.byStage.DAF || 0,
    d2c2: counts.byStage.D2C2 || 0,
    complete: counts.byStage.Complete || 0,
  };
};
